/**
 * Traces typeahead / commit / focus des U2000ComboBoxBase.
 * DEV : actif par défaut. Désactiver : localStorage.setItem('u2000ComboBoxTypeaheadDebug','0')
 * Forcer si besoin : localStorage.setItem('u2000ComboBoxTypeaheadDebug','1')
 */
export function u2000IsComboBoxTypeaheadDebugEnabled(): boolean {
  if (!import.meta.env.DEV) {
    return false;
  }
  if (typeof localStorage === 'undefined') {
    return true;
  }
  return localStorage.getItem('u2000ComboBoxTypeaheadDebug') !== '0';
}

export function u2000TraceComboBoxTypeahead(
  comboId: string,
  event: string,
  detail: Record<string, unknown>,
): void {
  if (!u2000IsComboBoxTypeaheadDebugEnabled()) {
    return;
  }
  console.info(`[U2000ComboBox:${comboId}]`, event, detail);
}
